<template>
  <div>
    <div v-for="user in users" :key="user.id" class="data-grid">
      <div>
        <label>Nombre</label>
        <span>{{ user.firstname }}</span>
      </div>
      <div>
        <label>Apellido</label>
        <span>{{ user.lastname }}</span>
      </div>
      <div>
        <label>Email corporativo</label>
        <span>{{ user.email }}</span>
      </div>
      <div>
        <label>Teléfono corporativo</label>
        <span>{{ user.phone }}</span>
      </div>
      <div>
        <label>CUIT / CUIL</label>
        <span>{{ user.cuil }}</span>
      </div>
      <div>
        <label>DNI / Pasaporte</label>
        <span>{{ user.dni ? user.dni : user.passport }}</span>
      </div>
      <!-- no esta claro que campo seria funcion asique le mande establishment role
      <div>
        <label>Función</label>
        <span>{{ user.establishmentRole }}</span>
      </div>
      -->
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

const userDetail = gql`
  query userDetail($currentUserToken: String!, $userId: Int!) {
    userDetail(currentUserToken: $currentUserToken, userId: $userId) {
      canBuy
      canSell
      createdAt
      cuil
      currentTime
      dni
      email
      establishmentRole
      firstname
      id
      lastname
      offerRole
      organization {
        adminId
        businessName
        city
        comments
        commercialAddress
        country
        cuit
        email
        establishments {
          id
        }
        id
        incomeTaxSituation
        ivaSituation
        logo
        mainActivity
        phone
        state
        userCanWrite
        users {
          id
        }
        zipcode
      }
      organizationId
      passport
      phone
      userCanWrite
    }
  }
`

export default {
  name: 'admin-data-tab',
  data () {
    return {
      users: [],
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    })
  },
  beforeMount() {
    this.getUsers()
  },
  watch: {
    currentUser() {
      this.getUsers()
    }
  },
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  methods: {
    getUsers() {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(userDetail),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          userId: this.organization.adminId
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.users = [res.data.data.userDetail]
        } else {
          console.log(res.data.errors)
        }
      }).catch(err => {
        console.log(err)
      })
    },

  }

}


</script>
